import React from 'react';

const CareersDomains: React.FC = () => {
  const domains = [
    {
      icon: '☁️',
      title: 'Cloud Engineering & DevOps',
      description: 'Design and build scalable cloud infrastructure, automate deployments, and ensure reliable systems that power modern applications.',
      link: '#'
    },
    {
      icon: '🤖',
      title: 'AI & Machine Learning',
      description: 'Develop intelligent systems, build ML models, and create AI solutions that solve real-world problems across industries.',
      link: '#'
    },
    {
      icon: '📊',
      title: 'Data Engineering & Analytics',
      description: 'Build data pipelines, create analytics platforms, and turn raw data into actionable insights for decision-making.',
      link: '#'
    },
    {
      icon: '🎓',
      title: 'Education & Training Solutions',
      description: 'Design learning experiences, create technical curricula, and help professionals upskill in emerging technologies.',
      link: '#'
    },
    {
      icon: '⚡',
      title: 'Product Engineering & Platforms',
      description: 'Build user-facing products, develop internal platforms, and create tools that enhance developer productivity.',
      link: '#'
    }
  ];

  return (
    <section className="careers-section careers-domains">
      <div className="container">
        <h2 className="section-title">Build your path at Global Sansys</h2>
        <p className="section-subtitle">
          Multiple domains under one roof, endless opportunities to grow and make an impact.
        </p>
        
        <div className="domains-grid">
          {domains.map((domain, index) => (
            <div key={index} className="domain-card">
              <div className="domain-icon">{domain.icon}</div>
              <h3>{domain.title}</h3>
              <p>{domain.description}</p>
              <a href={domain.link} className="domain-link">
                See roles in this domain →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareersDomains;